import React from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate, useLocation } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Cookies from "universal-cookie";
import ReceiptIcon from "@mui/icons-material/Receipt";
import {
    getRequisitionUUID,
    addRequisition,
    departmentKeyValue1,
    getActiveItemsByWarehouseid,
    getWarehouseKeyValueList,
} from "../../../services/index";
import AddIcon from "@mui/icons-material/Add";
import { updateRequisition } from "../../../services/Production/RequisitionServices";
import { Spinner } from "react-bootstrap";
import Button from "@mui/material/Button";
import {
    getRecipeDetails,
    getRecipeKeyValueListForRequisition,
} from "../../../services/Production/RecipeServices";
import { getFormattedNumber } from "../../utils/textUtils";

const RequisitionNew = () => {
    let navigate = useNavigate();
    let location = useLocation();
    let reqId = location?.state?.reqId;
    let loginData1 = new Cookies().get("loginData1");
    var curr = new Date();
    curr.setDate(curr.getDate());
    var date1 = curr.toISOString().substring(0, 10);

    const tempRow = {
        item: "",
        stock: "",
        qty: "",
        unit: "",
    };

    const [issInfo, setIssInfo] = useState({
        ware: { value: "", label: "Select Warehouse" },
        user: { value: loginData1.recordId, label: loginData1.fullName },
        dept: { value: "", label: "Select department" },
        date: date1,
        units: [{ label: "", value: "" }],
        selectedUnit: {
            label: "",
            value: "",
            stock: 0,
        },
    });
    const [rows, setRows] = useState([tempRow]);
    const [itemOptions, setItemOptions] = useState("");
    const [itemOptions2, setItemOptions2] = useState("");
    const [recipeOptions, setRecipeOptions] = useState(null);
    const [selectedRecipe, setSelectedRecipe] = useState(null);
    const [recipeList, setRecipeList] = useState(null);
    const [wareOptions, setWareOptions] = useState("");
    const [deptOptions, setDeptOptions] = useState("");
    const [requisitionDetails, setRequisitionDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [radioButton, setRadioButton] = useState(true);
    const [itemLoading, setItemLoading] = useState(false);

    useEffect(() => {
        if (reqId) {
            getRequisitionUUID(reqId).then((response) => {
                if (response.errorCode === 0) {
                    let res = response.responsePacket;
                    if (res.note === "INDG") {
                        setIssInfo({
                            ware: {
                                label: res.warehouseTitle,
                                value: res.warehouseId,
                            },
                            user: {
                                value: res.requisitionByUserId,
                                label: res.requisitionByUserTitle,
                            },
                            dept: {
                                label: res.requestingDepartmentTitle,
                                value: res.requestingDepartmentId,
                            },
                            date: res.requestDate,
                            note: "",
                            reqCode: res.requisitionCode,
                            requisitionId: res.recordId,
                        });
                        getRequisitionItems(res.warehouseId);
                        setRequisitionDetails(res);
                    } else {
                        setRadioButton(false);
                        setIssInfo({
                            ware: {
                                label: res.warehouseTitle,
                                value: res.warehouseId,
                            },
                            user: {
                                value: res.requisitionByUserId,
                                label: res.requisitionByUserTitle,
                            },
                            dept: {
                                label: res.requestingDepartmentTitle,
                                value: res.requestingDepartmentId,
                            },
                            date: res.requestDate,
                            note: "",
                            reqCode: res.requisitionCode,
                            requisitionId: res.recordId,
                        });
                        const uuidObj = { "key": res.note.split('::')[1] };
                        const quant = res.note.split('::')[3];
                        const _recipeList = res.requestedItemsBeanList.map((item) => ({
                            "itemId": item.itemId,
                            "itemTitle": item.itemTitle,
                            "quantity": (item.quantity / quant),
                            "quantityUnitId": item.unitId,
                            "quantityUnitTitle": item.unitTitle,
                            "totalQty": item.quantity
                        }))
                        setRecipeList(_recipeList);
                        getRecipeKeyValueListForRequisition().then((response) => {
                            const _res = response.responsePacket?.map((item) => ({
                                ...item,
                                label: item.value,
                            }));
                            setRecipeOptions(_res);
                            const _recipeOptions = _res?.find((item) => item.key === uuidObj.key);
                            setSelectedRecipe({ ..._recipeOptions, "qty": quant })
                        });
                    }
                } else {
                    toast(response.message);
                }
            });
        }
    }, []);

    useEffect(() => {
        getRequisitionItems(issInfo.ware.value);
    }, [radioButton]);

    useEffect(() => {
        getWarehouseKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setWareOptions(options);
            } else {
                toast(res.message);
            }
        });
        departmentKeyValue1().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setDeptOptions(options);
            } else {
                toast(res.message);
            }
        });
    }, []);

    const handleWare = (e) => {
        setRows([tempRow]);
        setIssInfo({ ...issInfo, ware: e });
        getRequisitionItems(e.value);
    };

    const getRequisitionItems = (warehouseId) => {
        let data = {
            page: 0,
            search: "",
            size: -1,
            uuid: warehouseId,
        };
        setItemLoading(true);
        if (radioButton) {
            getActiveItemsByWarehouseid(data).then((res) => {
                if (res.errorCode === 0) {
                    const options = res.responsePacket.data?.map((d) => (d.active && {
                        value: d.itemTitle,
                        itemId: d.itemId,
                        itemTitle: d.itemTitle,
                        label: (
                            <div className="selectItemOptions">
                                <div className="font-size-14 font-weight-bold">
                                    {d.itemTitle}
                                </div>
                                <div
                                    className={`row font-size-13 ${d.currentStockBoxQuantity <= 0 &&
                                        d.currentStockOpenQuantity <= 0
                                        ? "text-danger"
                                        : ""
                                        }`}
                                >
                                    <div className="col-6">
                                        Available Stock:
                                    </div>
                                    <div className="col-3">
                                        <span>
                                            {d.currentStockBoxQuantity?.toFixed(2)}{" "}({d.packUnitTitle})
                                        </span>
                                    </div>
                                    <div className="col-3">
                                        <span>
                                            {d.currentStockOpenQuantity?.toFixed(
                                                2
                                            )}{" "}
                                            ({d.unitName})
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ),
                        warehouseId: d.warehouseId,
                        warehouseTitle: d.warehouseTitle,
                        unitId: d.unitId,
                        unitName: d.unitName,
                        currentStockOpenQuantity: d.currentStockOpenQuantity,
                        currentStockBoxQuantity: d.currentStockBoxQuantity,
                        unitConversionTitle: d.unitConversionTitle,
                        unitConversion: d.unitConversion,
                        units: [
                            {
                                value: d.unitId,
                                label: d.unitName,
                                stock: d.currentStockOpenQuantity,
                            },
                            {
                                value: d.packUnitId,
                                label: d.packUnitTitle,
                                stock: d.currentStockBoxQuantity,
                            },
                        ],
                        selectedUnit: {
                            value: d.unitId,
                            label: d.unitName,
                            stock: d.currentStockBoxQuantity,
                        },
                    }));
                    setItemOptions(options);
                    setItemOptions2(options);
                    setItemLoading(false);
                } else {
                    toast(res.message);
                }
            });
        } else {
            getRecipeKeyValueListForRequisition().then((res) => {
                const _res = res.responsePacket?.map((item) => ({
                    ...item,
                    label: item.value,
                }));
                setRecipeOptions(_res);
            });
        }
    };

    useEffect(() => {
        if (
            requisitionDetails &&
            requisitionDetails.requestedItemsBeanList &&
            issInfo.ware.value !== "" &&
            itemOptions &&
            rows[0].item === ""
        ) {
            getSelectedItems(itemOptions);
        }
    }, [requisitionDetails, itemOptions]);

    // Get Pre selected requisition items
    const getSelectedItems = (options) => {
        const obj = [];
        const beanList = requisitionDetails.requestedItemsBeanList;
        for (let i = 0; i < beanList.length; i++) {
            for (let j = 0; j < options.length; j++) {
                if (beanList[i].itemId === options[j].itemId) {

                    let unitConversion = options[j].unitConversion?.split(":")[1];
                    let unitConversionTitle = options[j].unitConversionTitle?.split(":");
                    let updatedStock;
                    if (beanList[i].unitTitle === unitConversionTitle[0].trim()) {
                        updatedStock = ((parseFloat(options[j].currentStockOpenQuantity) / parseFloat(unitConversion)) + parseFloat(options[j].currentStockBoxQuantity));
                    } else {
                        updatedStock = ((parseFloat(options[j].currentStockBoxQuantity) * parseFloat(unitConversion)) + parseFloat(options[j].currentStockOpenQuantity));
                    }
                    let itemObj = {
                        item: {
                            label: options[j].itemTitle,
                            value: options[j].value,
                        },
                        stock: getFormattedNumber(updatedStock),
                        qty: beanList[i].quantity,
                        itemId: beanList[i].itemId,
                        units: options[j].units,
                        selectedUnit: {
                            value: beanList[i].unitId,
                            label: beanList[i].unitTitle,
                            stock: options[j].selectedUnit.stock,
                        },
                        currentStockBoxQuantity: options[j].currentStockBoxQuantity,
                        currentStockOpenQuantity: options[j].currentStockOpenQuantity,
                        unitConversion: options[j].unitConversion,
                        unitConversionTitle: options[j].unitConversionTitle,
                    };
                    obj.push(itemObj);
                    break;
                }
            }
        }
        if (obj.length > 0) {
            setRows(obj);
        }
    };

    const handleFilterItem = (rows) => {
        if (rows && rows.length > 0) {
            var setSend = false;
            var filterOptions = [];
            itemOptions2 &&
                itemOptions2?.map((a) => {
                    rows &&
                        rows?.map((b) => {
                            if (a.itemId === b?.itemId) {
                                setSend = true;
                            }
                        });
                    if (!setSend) {
                        filterOptions.push(a);
                    }
                    setSend = false;
                });
            setItemOptions(filterOptions);
        }
    }

    useEffect(() => {
        handleFilterItem(rows);
    }, [rows]);

    const handleAddRow = () => {
        setRows([...rows, tempRow]);
        handleFilterItem(rows);
    };

    const handleClear = (id, i) => {
        const obj = rows.slice();
        obj.splice(i, 1);
        handleFilterItem(obj);
        setRows(obj);
    };

    const handleQty = (e, i) => {
        const obj = [...rows];
        let qt = Number(e.target.value);

        if (qt <= obj[i].stock) {
            obj[i].qty = qt;
            setRows(obj);
        }
    };

    const handleItem = (e, i) => {
        const obj = [...rows];
        obj[i].item = {
            label: e.itemTitle,
            value: e.itemTitle,
        };
        obj[i].itemId = e.itemId;
        obj[i].qty = "";
        obj[i].units = e.units;
        obj[i].unitConversion = e.unitConversion;
        obj[i].selectedUnit = e.selectedUnit;
        obj[i].unitConversionTitle = e.unitConversionTitle;
        obj[i].currentStockBoxQuantity = e.units[1].stock;
        obj[i].currentStockOpenQuantity = e.units[0].stock;

        let unitConversion = e.unitConversion.split(":")[1];
        let unitConversionTitle = e.unitConversionTitle.split(":")[1];
        obj[i].unit = unitConversionTitle;
        let updatedStock;
        updatedStock = (e.units[1].stock * unitConversion) + e.units[0].stock;
        obj[i].stock = getFormattedNumber(updatedStock);

        handleFilterItem(obj)
        setRows(obj);
    };

    const handleSave = () => {
        if (issInfo.ware === "") {
            toast("Select Warehouse");
            return;
        }

        if (issInfo.user === "") {
            toast("Select user");
            return;
        }
        if (issInfo.dept === "") {
            toast("Select Department");
            return;
        }
        setLoading(true);
        let itemBeanList = [];
        if (radioButton) {
            rows?.map((item) => {
                if (item.qty > 0) {
                    const openUnitTitle = item?.unitConversionTitle?.split(":")[1].trim();
                    const openUnitData = item?.units?.find((value) => value.label === openUnitTitle)
                    itemBeanList.push({
                        itemId: item.itemId,
                        itemTitle: item.item.label,
                        quantity: item.qty,
                        unitId: item.selectedUnit.value,
                        unitTitle: item.selectedUnit.label,
                        warehouseId: item.warehouseId,
                        warehouseTitle: item.warehouseTitle,
                        inHandQuantityUnitTitle: openUnitData.label,
                        inHandQuantityUnitTitleUuid: openUnitData.value
                    });
                }
            });
            if (itemBeanList?.length === 0) {
                toast("Select item");
                setLoading(false);
                return;
            }
        } else {
            if (!selectedRecipe) {
                toast("Select Recipe");
                setLoading(false);
                return;
            }
            if (!selectedRecipe.qty) {
                toast("Quantity cannot be empty");
                setLoading(false);
                return;
            }
            if (selectedRecipe.qty <= 0) {
                toast("Quantity must be greater than 0");
                setLoading(false);
                return;
            }

            recipeList?.map((item) => {
                itemBeanList.push({
                    itemId: item.itemId,
                    itemTitle: item.itemTitle,
                    quantity: item.totalQty,
                    unitId: item.quantityUnitId,
                    unitTitle: item.quantityUnitTitle,
                    warehouseId: wareOptions.value,
                    warehouseTitle: wareOptions.label,
                    inHandQuantityUnitTitleUuid: item.quantityOpenUnitId,
                    inHandQuantityUnitTitle: item.quantityOpenUnitTitle
                })
            })
        }
        const data = {
            actingUserId: "",
            actingUserTitle: "",
            actionDate: "",
            isAccepted: false,
            isRejected: false,
            note: radioButton ? "INDG" : `RECI::${selectedRecipe.key}::${selectedRecipe.value}::${selectedRecipe.qty}::${selectedRecipe.value2}`,
            requestDate: curr.toISOString(),

            requestedItemsBeanList: itemBeanList,

            requestingUserId: issInfo.user.value,
            requestingUserTitle: issInfo.user.label,
            requestingDepartmentId: issInfo.dept.value,
            requestingDepartmentTitle: issInfo.dept.label,
            warehouseId: issInfo.ware.value,
            warehouseTitle: issInfo.ware.label,
        };

        if (reqId) {
            updateRequisition(reqId, data)
                .then((res) => {
                    if (res.errorCode === 0) {
                        toast(res.message);
                        navigate("/requisition/");
                        setLoading(false);
                    } else {
                        toast(res.message);
                        setLoading(false);
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    return;
                });
        } else {
            addRequisition(data)
                .then((res) => {
                    if (res.errorCode === 0) {
                        toast(res.message);
                        navigate("/requisition/");
                        setLoading(false);
                    } else {
                        toast(res.message);
                        setLoading(false);
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    return;
                });
        }
    };

    const handleSelectUnit = (e, i) => {
        const obj = [...rows];

        obj[i].selectedUnit = e;

        let unitConversion = obj[i].unitConversion?.split(":")[1];
        let unitConversionTitle = obj[i].unitConversionTitle?.split(":");

        let updatedStock;

        if (e.label === unitConversionTitle[0].trim()) {
            updatedStock = ((parseFloat(obj[i].currentStockOpenQuantity) / parseFloat(unitConversion)) + parseFloat(obj[i].currentStockBoxQuantity));
        } else {
            updatedStock = ((parseFloat(obj[i].currentStockBoxQuantity) * parseFloat(unitConversion)) + parseFloat(obj[i].currentStockOpenQuantity));
        }

        if (updatedStock < obj[i].qty) {
            obj[i].qty = getFormattedNumber(updatedStock);
        }
        obj[i].stock = getFormattedNumber(updatedStock);

        setRows(obj);
    };

    const handleRadioButton = (e) => {
        setRadioButton(!radioButton);
    };

    const handleRecipeSelect = (e) => {
        setSelectedRecipe({ ...e, "qty": 1 });
        getRecipeDetails(e.key).then((res) => {
            const _res = res.responsePacket.map((value) => ({ ...value, "totalQty": value.quantity }));
            setRecipeList(_res);
        });
    };

    const multiplyQty = (e) => {
        const { value } = e.target;
        setSelectedRecipe((prev) => ({ ...prev, "qty": value }));
        if (value > 0) {
            const _recipeList = recipeList.map((item) => ({ ...item, "totalQty": item.quantity * value }))
            setRecipeList(_recipeList);
        }
    }

    const checkForDisable = () => {
        if (issInfo.ware.value === "" || issInfo.dept.value === "") {
            return true;
        }
        return false;
    };

    return (
        <>
            <div style={{ paddingLeft: "20px" }}>
                <h1 className="fill list-header d-flex  align-items-center bg-white p-3 border-bottom">
                    <ReceiptIcon />
                    {reqId ? "Edit " : "New "} Requisition
                    <span className="text-primary font-weight-bold">
                        {issInfo?.reqCode ? ` - ${issInfo.reqCode}` : ""}
                    </span>
                </h1>

                <br />
                <table className="customTable">
                    <tbody>
                        <tr>
                            <td>Warehouse:</td>
                            <td>
                                <Select
                                    isDisabled={reqId ? true : false}
                                    value={issInfo.ware}
                                    options={wareOptions}
                                    onChange={(e) => handleWare(e)}
                                />
                            </td>
                        </tr>
                        {/* TODO */}
                        <tr>
                            <td>Department:</td>
                            <td>
                                <Select
                                    isDisabled={reqId ? true : false}
                                    value={issInfo.dept}
                                    options={deptOptions}
                                    onChange={(e) =>
                                        setIssInfo({ ...issInfo, dept: e })
                                    }
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Date:</td>
                            <td>
                                <input
                                    autoComplete="off"
                                    disabled={reqId ? true : false}
                                    type="date"
                                    className="form-control"
                                    value={issInfo.date}
                                    onChange={(e) =>
                                        setIssInfo({
                                            ...issInfo,
                                            date: e.target.value,
                                        })
                                    }
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className="py-3">Requisition By:</td>
                            <td className="py-3">
                                <div className="d-flex ">
                                    <div className="mr-5 d-flex align-items-center ">
                                        <input
                                            type="radio"
                                            className="pb-3 mr-2"
                                            name="ingredient"
                                            id="isItem"
                                            // disabled={id ? true : false}
                                            checked={radioButton}
                                            onChange={(e) =>
                                                handleRadioButton(!!e.target.value)
                                            }
                                        />
                                        <label htmlFor="isItem" className="m-0 p-0">Item</label>
                                    </div>
                                    <div className="d-flex align-items-center ">
                                        <input
                                            type="radio"
                                            className="pb-3 mr-2"
                                            name="ingredient"
                                            id="isRecipe"
                                            checked={!radioButton}
                                            onChange={(e) =>
                                                handleRadioButton(!!!e.target.value)
                                            }
                                        />
                                        <label htmlFor="isRecipe" className="m-0 p-0">Recipe</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <br />
                {radioButton && (
                    <table className="customTable">
                        <tbody>
                            <tr>
                                <td></td>
                                <td>Item</td>
                                <td>Stock</td>
                                <td>Qty</td>
                                <td>Unit</td>
                                <td></td>
                            </tr>
                            {rows && rows?.map((data, i) => {
                                return (
                                    <tr key={i}>
                                        <td>
                                            <div className={itemLoading ? "spinner-loader" : ""}></div>
                                        </td>
                                        <td className="selectMenuItemList">
                                            <Select
                                                isDisabled={checkForDisable() || itemLoading}
                                                options={itemOptions}
                                                value={data.item}
                                                onChange={(e) =>
                                                    handleItem(e, i)
                                                }
                                            />
                                        </td>
                                        <td style={{ width: "100px" }}>
                                            <span>{data?.stock}</span>
                                        </td>
                                        <td style={{ width: "100px" }}>
                                            <input
                                                autoComplete="off"
                                                disabled={checkForDisable()}
                                                type="number"
                                                min={0}
                                                value={data.qty}
                                                onChange={(e) =>
                                                    handleQty(e, i)
                                                }
                                            />
                                        </td>
                                        <td>
                                            <Select
                                                isDisabled={checkForDisable()}
                                                value={data.selectedUnit}
                                                options={data.units}
                                                onChange={(e) =>
                                                    handleSelectUnit(e, i)
                                                }
                                            />
                                        </td>
                                        <td
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleClear(data.item.value, i)}
                                        >
                                            {rows.length > 1 && (<i className="fa fa-times"></i>)}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
                {!radioButton && (
                    <table className="customTable">
                        <thead>
                            <tr>
                                <td>Select Recipe</td>
                                <td className="text-right">Qty</td>
                                <td className="text-right">Unit</td>
                            </tr>
                            <tr>
                                <td className="selectMenuItemList">
                                    {/* <Select isDisabled={checkForDisable()} options={itemOptions} value={data.item} onChange={(e) => handleItem(e, i)} /> */}
                                    <Select
                                        isDisabled={checkForDisable()}
                                        options={recipeOptions}
                                        value={selectedRecipe}
                                        onChange={(e) => handleRecipeSelect(e)}
                                    />
                                </td>
                                <td>
                                    {/* <input autoComplete="off" disabled={checkForDisable()} type="number" min={0} value={data.qty} onChange={(e) => handleQty(e, i)} /> */}
                                    <input
                                        autoComplete="off"
                                        disabled={checkForDisable()}
                                        type="number"
                                        value={selectedRecipe?.qty}
                                        onChange={(e) => multiplyQty(e)}
                                    />
                                </td>
                                <td>
                                    {/* <input autoComplete="off" disabled={checkForDisable()} type="number" min={0} value={data.qty} onChange={(e) => handleQty(e, i)} /> */}
                                    <input
                                        autoComplete="off"
                                        disabled={true}
                                        className="text-right"
                                        style={{ padding: "5px 8px", width: "80px" }}
                                        value={selectedRecipe?.value2}
                                    />
                                </td>
                            </tr>
                        </thead>
                        {recipeList && <tbody>
                            <tr>
                                <td>Item</td>
                                <td className="text-right">Qty</td>
                                <td className="text-right">Unit</td>
                            </tr>
                            {
                                recipeList?.map((data, i) => {
                                    return (
                                        <tr key={i}>
                                            <td className="selectMenuItemList">
                                                <input
                                                    autoComplete="off"
                                                    className="text-left"
                                                    disabled
                                                    type="text"
                                                    style={{ width: "300px" }}
                                                    value={data.itemTitle}
                                                />
                                            </td>
                                            <td style={{ width: "100px" }}>
                                                <input
                                                    autoComplete="off"
                                                    disabled
                                                    type="text"
                                                    value={data.totalQty.toFixed(3)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    disabled
                                                    className="mx-auto"
                                                    type="text"
                                                    value={data.quantityUnitTitle}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                        </tbody>}
                    </table>
                )}

                {!checkForDisable() && (
                    <>
                        {radioButton && (
                            <div>
                                <button
                                    id="ember1426"
                                    className="btn btn-default addbtn mt-3"
                                    onClick={handleAddRow}
                                >
                                    <AddIcon style={{ color: "blue" }} /> New
                                    Row
                                </button>
                            </div>
                        )}
                        {(rows[0].item !== "" || recipeList) && (
                            <>
                                <br />
                                <div>
                                    {loading ? (
                                        <Button variant="contained">
                                            <Spinner />
                                        </Button>
                                    ) : (
                                        <Button
                                            variant="contained"
                                            onClick={handleSave}
                                        >
                                            Save
                                        </Button>
                                    )}
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>
            <Toaster />
        </>
    );
};

export default RequisitionNew;
